module.exports = __webpack_public_path__ + "img/vertical-bottom-left.ac72df80.png";